<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Transfer Pickups</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')" (keydown.enter)="$event.preventDefault()"></button>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <form [formGroup]="transferPickupsForm">
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-2">
                            <label class="form-label">Date <span class="mandatory">*</span> </label>
                            <input type="date" class="form-control  form-control-sm" formControlName="txtDate"
                                [ngClass]="{'is-invalid':(isFormSubmitted||transferPickupsForm.get('txtDate').touched)&& transferPickupsForm.get('txtDate').errors}">
                            <div class="invalid-feedback"
                                *ngIf="(isFormSubmitted||transferPickupsForm.get('txtDate').touched)&& transferPickupsForm.get('txtDate').errors">
                                <span *ngIf="transferPickupsForm.get('txtDate').errors.required">Date is Required</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-2">
                            <label class="form-label">From <span class="mandatory">*</span></label>
                            <ng-select placeholder="Select" formControlName="ddlFrom" [items]="fieldExecutiveList"
                                bindLabel="username" [bindValue]="'id'"
                                class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                [ngClass]="{'is-invalid':(isFormSubmitted||transferPickupsForm.get('ddlFrom').touched)&& transferPickupsForm.get('ddlFrom').errors}">
                            </ng-select>
                            <div class="invalid-feedback"
                                *ngIf="(isFormSubmitted||transferPickupsForm.get('ddlFrom').touched)&& transferPickupsForm.get('ddlFrom').errors">
                                <span *ngIf="transferPickupsForm.get('ddlFrom').errors.required">Field Executive is
                                    Required</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-2">
                            <label class="form-label">To <span class="mandatory">*</span></label>
                            <ng-select placeholder="Select" formControlName="ddlTo" [items]="fieldExecutiveList"
                                bindLabel="username" [bindValue]="'id'"
                                class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                [ngClass]="{'is-invalid':(isFormSubmitted||transferPickupsForm.get('ddlTo').touched)&& transferPickupsForm.get('ddlTo').errors}">
                            </ng-select>
                            <div class="invalid-feedback"
                                *ngIf="(isFormSubmitted||transferPickupsForm.get('ddlTo').touched)&& transferPickupsForm.get('ddlTo').errors">
                                <span *ngIf="transferPickupsForm.get('ddlTo').errors.required">Field Executive is
                                    Required</span>
                            </div>
                        </div>
                    </div>
                </div>


            </form>
        </div>
    </div>

</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="onSaveClick()">Save</button>
</div>